import { render } from "./reabrirProposta.vue?vue&type=template&id=1def1a62"
import script from "./reabrirProposta.vue?vue&type=script&lang=js"
export * from "./reabrirProposta.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__